<div class="box-novo-compromisso" *ngIf="showModal" (click)="onBackgroundClick($event)">
  <div class="box-formulario" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5>Nova tarefa</h5>
      </div>
      <div class="col-md-6 text-right" style="padding-top: 5px;">
        <i (click)="fecharModal()" class="fa fa-close"></i>
      </div>
      <hr class="hr-titulo">
      <form [formGroup]="formNovoCompromisso">
        <div class="row">
          <div class="col-md-12">
            <label for="descricao">Descrição</label>
            <input type="text" id="descricao" class="form-control" formControlName="descricao"
                   placeholder="Digite a descrição"
                   [ngClass]="{'is-invalid': formNovoCompromisso.controls['descricao'].invalid}">
          </div>
          <div class="col-md-12" style="padding-top: 10px;">
            <label for="descricaoDetalhada">Descrição detalhada</label>
            <textarea class="form-control" formControlName="descricaoDetalhada"
                      placeholder="Digite a descrição detalhada"
                      [ngClass]="{'is-invalid': formNovoCompromisso.controls['descricaoDetalhada'].invalid}"></textarea>
          </div>
          <div class="col-md-6" style="padding-top: 10px;">
            <label for="dataInicial">Data Inicio</label>
            <input type="datetime-local" class="form-control"
                   formControlName="dataInicial"
                   [min]="dataInicioMinima"
                   (change)="onDataInicialAlterada()"
                   id="dataInicial">
          </div>
          <div class="col-md-6" style="padding-top: 10px;">
            <label for="dataPrevisaoFinalizacao">Previsão de término</label>
            <input type="datetime-local" class="form-control"
                   formControlName="dataPrevisaoFinalizacao"
                   [min]="dataPrevisaoMinima"
                   id="dataPrevisaoFinalizacao">
          </div>
          <div class="col-md-6" style="padding-top: 10px;margin-top: 20px;">
            <button class="btn btn-warning" (click)="fecharModal()">Cancelar</button>
          </div>
          <div class="col-md-6 pull-right text-right" style="padding-top: 10px;margin-top: 20px;">
            <button class="btn btn-primary" (click)="salvar()">Salvar</button>
          </div>
        </div>
      </form>
    </div>
  </div>

</div>
